var cancelForm = function () {
    $('[data-id="cancelForm"]').on('click', function () {
        var formName = $('input#FormName').attr("value");
        var form = $('form#' + formName);
            form.append('<input type="hidden" name="FormSubmitAction" value="Cancel" />');
            form.validate().cancelSubmit = true; // disable unobtusive validation on the form submit
            form.on('submit');
    });
};
